import $http from "../../axios";
import { Notification, MessageBox } from "element-ui";

export async function fetchTypeVehicles({ commit }, params) {
    await $http
        .get(`/api/vehiculo-tipos`, {
            params
        })
        .then(response => {
            commit("setTypeVehicles", response.data.data);
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 2000,
                customClass: "notification-box"
            });
        });
}

export async function createVehicle({ commit }, data) {
    await $http
        .post(`/api/tercero-vehiculo`, data)
        .then(response => {
            Notification.success({
                title: "Exito!",
                message: "Vehículo creado con exito!",
                type: "success",
                duration: 2000,
                customClass: "notification-box"
            });
            commit('CreateClientComponent/setContactVehicleId', response.data.data.id, {root: true})
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: 'La placa ya existe en el sistema.',
                type: "error",
                duration: 2000,
                customClass: "notification-box"
            });
        });
}

export async function updateVehicle({ commit }, data) {
    await $http
        .put(`/api/tercero-vehiculo/${data.id}`, data)
        .then(response => {
            Notification.success({
                title: "Exito!",
                message: "Vehículo actualizado con exito!",
                type: "success",
                duration: 2000,
                customClass: "notification-box"
            });
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 2000,
                customClass: "notification-box"
            });
        });
}

export async function deleteVehicle({ commit }, id) {
    await $http
        .delete(`/api/tercero-vehiculo/${id}`)
        .then(response => {
            Notification.success({
                title: "Exito!",
                message: "Vehículo eliminado con exito!",
                type: "success",
                duration: 2000,
                customClass: "notification-box"
            });
        })
        .catch(error => {
            Notification.error({
                title: "Error!",
                message: error.message,
                type: "error",
                duration: 2000,
                customClass: "notification-box"
            });
        });
}

export async function fetchCountries({ commit, state }) {
  await $http
    .get("/api/pais")
    .then(response => {
      commit("setCountries", response.data.data);
    })
    .catch(error => {
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}

export async function fetchContacts({commit, state, rootState, dispatch}, contact_type = 1) {
    state.params_client.type = 'is_customer';
    let params = state.params_client;
    await $http.get('/api/terceros-lite', {params})
        .then(async response => {

            let contact;
            let contacts = response.data.data;
            contact = contacts.find(c => c.identification === state.params_client.filter);
            if (contact) {
                commit('setContacts', [contact]);
                commit('setClient', contact);
            } else {
                commit('setContacts', contacts);
                let client = JSON.parse(JSON.stringify(state.client));
                client.identification = null;
                commit('setClient', client);
            }
        })
        .catch(error => {
            console.error(error);
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

export async function fetchContactById({commit, state, rootState}, id) {
    await $http.get('/api/terceros/' + id)
        .then(async response => {
            const client = response.data.data;
            commit('setClient', client);
        })
        .catch(error => {
            Notification.error({
                title: 'Error!',
                message: error.message,
                type: 'error',
                duration: 1500,
                customClass: 'notification-box'
            });
        });
}

export async function validateLicensePlate ({commit, state}, license_plate) {
    return new Promise(async (resolve, reject) => {
        await $http.get('/api/validar-placa?license_plate=' + license_plate)
            .then(async response => {
                resolve(response.data.data);
            })
            .catch(error => {
                Notification.error({
                    title: 'Error!',
                    message: error.message,
                    type: 'error',
                    duration: 1500,
                    customClass: 'notification-box'
                });
                reject();
            });
    });
}


// WEBPACK FOOTER //
// ./src/modules/contact-vehicles/actions.js